import {emojiRegex} from './emojiRegex';

/**
 * @name splitStringByEmojis
 */
export const splitStringByEmojis = (string: string): string[] =>
  string.split(emojiRegex);
